export const VEHICLE_MANAGEMENT = {
  BASE_PATH: "/trip/vehicle-management/",
  GET_ALL: "/trip/vehicle-management",
  CREATE: "/trip/vehicle-management/create",
  GET_ONE: "/trip/vehicle-management/edit/",
  UPDATE: "/trip/vehicle-management/update/",
  DELETE: "/trip/vehicle-management/delete/",
  ADD_NEW_TITLE: "Add New Vehicle",
};
